import React from 'react';
import { PRIORITY_COLORS, CRITICALITY_COLORS, TASK_STATUS_LABELS, TASK_STATUS_COLORS } from '../../utils/constants';
import { formatDate, isOverdue } from '../../utils/dates';
import Badge from '../shared/Badge';

function TaskRow({ task, onClick }) {
  const overdue = isOverdue(task.due_date) && !['hecha', 'cancelada'].includes(task.status);
  return (
    <div className="list-row clickable" onClick={onClick}>
      <span className="priority-dot" style={{ background: PRIORITY_COLORS[task.priority], flexShrink: 0 }} />
      <div className="list-row__main">
        <span className="list-row__title">
          {task.title?.slice(0, 70)}{task.title?.length > 70 ? '…' : ''}
        </span>
        <div className="list-row__meta">
          {task.criticality && <Badge label={task.criticality} color={CRITICALITY_COLORS[task.criticality]} />}
          {task.estimated_hours && <span className="meta-chip">~{task.estimated_hours}h</span>}
          {task.due_date && (
            <span className={`meta-chip${overdue ? ' danger' : ''}`}>
              📅 {formatDate(task.due_date)}
            </span>
          )}
          {task.risk_count > 0 && <span className="meta-chip danger">⚠ {task.risk_count}</span>}
          {(task.entry_id || task.linked_entry_id) && <span className="meta-chip" style={{ color: 'var(--accent)', opacity: 0.8 }}>📨</span>}
        </div>
      </div>
      <Badge
        label={TASK_STATUS_LABELS[task.status] || task.status}
        color={TASK_STATUS_COLORS[task.status] || 'var(--text-muted)'}
      />
    </div>
  );
}

export default TaskRow;
